import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as congNoConstant from './constants'
import * as congNoAction from './actions'
import { takeEvery } from 'redux-saga'
import { transfersFromCached } from '../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function* congNoListRequestFlow(action) {
  try {
    // grab the client from our action
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_KH_REPORT_LIST_API,
      payload
    )

    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoListSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(congNoAction.congNoListError(error))
  }
}

function* congNoCtListRequestFlow(action) {
  try {
    // grab the client from our action
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNOCT_KH_LIST_API,
      payload
    )
    const result = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoCtListSuccess())
    if (typeof callback == 'function') {
      yield call(callback, result);
    }

  } catch (error) {
    yield put(congNoAction.congNoCtListError(error))
  }
}

function* reportExportXlsRequestFlow(action) {
  try {
    const { payload, callback } = action
    let url = ""
    if (payload.loai && payload.loai == 1) {
      url = congNoConstant.CONGNOCT_KH_EXPORT_XLS_API + "?nv=" + payload.nv + "&kh=" + payload.kh + "&t=" + payload.t + "&d=" + payload.d
    }
    else {
      url = congNoConstant.CONGNO_KH_EXPORT_XLS_API + "?nv=" + payload.nv + "&kh=" + payload.kh + "&t=" + payload.t + "&d=" + payload.d
    }
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    )

    // grab the client from our action
    const results = yield call(handleFileRequest, request)
    // dispatch the action with our widgets!
    yield put(congNoAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(congNoAction.reportExportXlsError(error))
  }
}

function* congNoDvhcListRequestFlow(action) {
  try {
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_KH_DVHC_LIST_API,
      payload
    )
    // grab the client from our action
    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoDvhcListSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }

  } catch (error) {
    yield put(congNoAction.congNoDvhcListError(error))
  }
}

function* congNoNvkdListRequestFlow(action) {
  try {
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_KH_NVKD_LIST_API,
      payload
    )
    // grab the client from our action
    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvkdListSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }

  } catch (error) {
    yield put(congNoAction.congNoNvkdListError(error))
  }
}

function* congNoDsKhListRequestFlow(action) {
  try {
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_KH_KH_LIST_API,
      payload
    )
    // grab the client from our action
    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoDsKhListSuccess(transfersFromCached(results.data)))
    if (typeof callback == 'function') {
      yield call(callback, transfersFromCached(results.data));
    }

  } catch (error) {
    yield put(congNoAction.congNoDsKhListError(error))
  }
}

function* congNoNvUpdateRequestFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      congNoConstant.CONGNO_KH_UPDATE_API,
      payload
    )
    // grab the client from our action
    const response = yield call(handleRequest, request)
    if (response.code != 200) {
      return yield put(congNoAction.congNoNvUpdateError(response.message))
    }
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvUpdateSuccess(response));
    if (typeof callback == 'function') {
      yield call(callback, response);
    }
  } catch (error) {
    yield put(congNoAction.congNoNvUpdateError(error))
  }
}
function* congNoNhanVienByKhListRequestFlow(action) {
  try {
    // grab the client from our action
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_NV_BY_KH_LIST_API,
      payload
    )

    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNhanVienByKhListSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(congNoAction.congNoNhanVienByKhListError(error))
  }
}


function* congNoNvExportXlsRequestFlow(action) {
  try {
    const { payload, callback } = action
    var url = congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_API + "?nv=" + payload.nv + "&t=" + payload.t + "&d=" + payload.d
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    )
    // grab the client from our action
    const results = yield call(handleFileRequest, request)
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(congNoAction.congNoNvExportXlsError(error))
  }
}
function* congNoKhUploadRequestFlow(action) {
  try {
    // grab the client from our action
    const { payload, callback } = action
    const request = axiosApi().post(
      congNoConstant.CONGNO_NV_BY_KH_UPDATE_TONDAU_API,
      payload
    )

    const results = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvUploadSuccess(results))
    if (typeof callback == 'function') {
      yield call(callback, results);
    }
  } catch (error) {
    yield put(congNoAction.congNoNvUploadError(error))
  }
}
function* congNoKhachHangWatcher() {
  yield [
    takeLatest(congNoConstant.CONGNO_KH_NVKD_LIST_REQUESTING, congNoNvkdListRequestFlow),
    takeLatest(congNoConstant.CONGNO_KH_KH_LIST_REQUESTING, congNoDsKhListRequestFlow),
    takeLatest(congNoConstant.CONGNO_KH_LIST_REQUESTING, congNoListRequestFlow),
    takeLatest(congNoConstant.CONGNOCT_KH_LIST_REQUESTING, congNoCtListRequestFlow),
    takeLatest(congNoConstant.CONGNO_KH_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(congNoConstant.CONGNO_KH_DVHC_LIST_REQUESTING, congNoDvhcListRequestFlow),
    takeLatest(congNoConstant.CONGNO_KH_UPDATE_REQUESTING, congNoNvUpdateRequestFlow),
    takeLatest(congNoConstant.CONGNO_NV_BY_KH_LIST_REQUESTING, congNoNhanVienByKhListRequestFlow),
    takeLatest(congNoConstant.CONGNO_NV_BY_KH_EXPORT_XLS_REQUESTING, congNoNvExportXlsRequestFlow),
    takeLatest(congNoConstant.CONGNO_NV_BY_KH_UPLOAD_REQUESTING, congNoKhUploadRequestFlow)
  ]
}

export default congNoKhachHangWatcher



// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/sagas.js